import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "dm_box"
};
var _hoisted_2 = {
  class: "dm_main"
};
var _hoisted_3 = {
  ref: "editorElem",
  class: "eidtor",
  style: {
    "text-align": "left"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, null, 512)])]);
}